<p-table [value]="donnee" [responsive]="true">
  <ng-template pTemplate="header">

    <tr>
      <th rowspan="2">Date</th>
      <th colspan="2">Moderation</th>
      <th colspan="2">Description</th>
      <th colspan="2">Lien vers site Web PTL</th>
      <th colspan="2">Liens réseaux sociaux</th>
      <th colspan="2">Photos</th>
      <th colspan="2">Photos</th>
      <th colspan="2">Offre Bons Plans</th>
      <th rowspan="2">Total</th>
    </tr>
    <tr>
      <th>Nouveau</th>
      <th>Retour </th>
      <th>Nouveau</th>
      <th>Retour</th>
      <th>Nouveau</th>
      <th>Retour</th>
      <th>Nouveau</th>
      <th>Retour</th>
      <th>Nouveau</th>
      <th>Retour</th>
      <th>Nouveau</th>
      <th>Retour</th>
      <th>Nouveau</th>
      <th>Retour</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-sale>
    <tr>
      <td>{{sale.date}}</td>
      <td>{{sale.moderation_nouveau}}</td>
      <td>{{sale.moderation_retour}}</td>
      <td>{{sale.description_nouveau}}</td>
      <td>{{sale.description_retour}}</td>
      <td>{{sale.site_web_nouveau}}</td>
      <td>{{sale.site_web_retour}}</td>
      <td>{{sale.lien_reseaux_nouveau}}</td>
      <td>{{sale.lien_reseaux_retour}}</td>
      <td>{{sale.photo_nouveau}}</td>
      <td>{{sale.photo_retour}}</td>
      <td>{{sale.logo_nouveau}}</td>
      <td>{{sale.logo_retour}}</td>
      <td>{{sale.offre_nouveau}}</td>
      <td>{{sale.offre_retour}}</td>
      <td style="font-weight: bold; text-align: center;"> {{parse(sale.offre_retour) + parse(sale.offre_nouveau) + parse(sale.logo_retour) + parse(sale.logo_nouveau) + parse(sale.photo_retour) + parse(sale.photo_nouveau) + parse(sale.lien_reseaux_retour) + parse(sale.photo_nouveau) + parse(sale.lien_reseaux_retour) + parse(sale.lien_reseaux_nouveau) + parse(sale.site_web_retour) + parse(sale.site_web_nouveau) + parse(sale.moderation_nouveau) + parse(sale.moderation_retour) + parse(sale.description_nouveau) + parse(sale.description_retour)}}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer">
    <tr>
      <td >Total</td>
      <td>100</td>
      <td>38</td>
      <td>6</td>
      <td>15</td>
      <td>21</td>
      <td>18</td>
      <td>21</td>
      <td>18</td>
      <td>21</td>
      <td>18</td>
      <td>21</td>
      <td>18</td>
      <td>21</td>
      <td>18</td>
      <td style="text-align: center;">456</td>
    </tr>
  </ng-template>
</p-table>
